import { Pot } from '@aslanpay/portal-common-lib';
import * as yup from 'yup';

export interface TransferPotInfo {
  fromPotName: string;
  toPotName: string;
  points: number;
}

export interface TransferPointsFormProps {
  companyId: string;
  onClose: () => void;
  onSuccess?: (info: TransferPotInfo) => void;
  onError?: (info: TransferPotInfo) => void;
  originPot: Pot;
}

export interface TransferPointsFormFields {
  amount?: string;
  destinationPot?: string;
}

export const createSchema = (maxBalance: number) =>
  yup.object({
    amount: yup
      .string()
      .required('Amount is required')
      .test('is-number', 'Enter a valid number', (value) => {
        const num = parseFloat(value ?? '');
        return !Number.isNaN(num);
      })
      .test('min-balance', 'The amount must be greater than zero.', (value) => {
        const num = parseFloat(value ?? '');
        return !Number.isNaN(num) && num > 0;
      })
      .test('max-balance', 'Amount exceeds available balance', (value) => {
        const num = parseFloat(value ?? '');
        return !Number.isNaN(num) && num <= maxBalance;
      }),
    destinationPot: yup.string().required('A destination pot is required'),
  });

export const DEFAULT_CREATE_POT_FORM_DATA: TransferPointsFormFields = {
  amount: undefined,
  destinationPot: undefined,
};

export const PREDEFINED_AMOUNTS = [
  { label: '1k', value: '1000' },
  { label: '5k', value: '5000' },
  { label: '10k', value: '10000' },
  { label: 'All', value: '__all__' },
];
